'use strict';

/* globals $ */

var _ = require('lodash');
var PostArticle = require('../../items/post-article.jsx');
var PostVideo = require('../../items/post-video.jsx');

var RecommendationAdapter = {
    _page: 0,
    _limit: 10,
    _photoSize: '360x171/smart,544x258/smart,593x281/smart,695x329/smart,766x363/smart',
    _smallPhotoSize: '360x171_smart',
    _mediumPhotoSize: '544x258_smart',
    _largePhotoSize: '593x281_smart',
    _extraLargePhotoSize: '695x329_smart',
    _extraExtraLargePhotoSize: '766x363_smart',

    request: function(config) {
        return $.ajax({
            url: this.getRequestURL(config),
            cache: true,
            crossDomain: true,
            dataType: 'jsonp',
            timeout: 3000,
            jsonpCallback: 'bastian_recommendation_callback'
        });
    },

    getRequestURL: function(config) {
        var contentId = (config.recommendationUrl.match(/client_id=/)?
            '&content_id=feed' : '/feed?type=bastian');

        var url = _.template(
            '<%= base %>' +
            '<%= contentId %>' +
            '&limit=<%= limit %>' +
            '&photo_size=<%= photoSize %>' +
            '&page=<%= page %>')({
                base: config.recommendationUrl,
                contentId: contentId,
                limit: this._limit,
                photoSize: this._photoSize,
                page: this.getNextDataPageNumber()
            });

        return url;
    },

    getNextDataPageNumber: function() {
        return this._page += 1;
    },

    handleReceivedPosts: function(data, postStore) {
        var hasNextPage = this.hasNextPage(data);
        postStore._hasNextPage = hasNextPage;

        if (hasNextPage === false) {
            postStore.emit('unmount-load-more');
        }

        data = this.removePublieditorial(data);

        var posts = data.map(_.bind(this.translate, this));
        return posts;
    },

    translate: function(post) {
        var transformed = {
            klass: PostArticle,
            created: { time: post.issued },
            isRecommended: true
        };

        var content = {
            chapeu: {
                label: this._resolveHeaderLabel(post),
                url: this._resolveHeaderUrl(post)
            },
            url: post.url,
            title: post.title,
            summary: post.caption
        };

        if (post.pubeditorial) transformed.pubeditorial = post.pubeditorial;

        if (post.photos) {
            content.image = {
                sizes: {
                    S: {url: ""},
                    M: {url: ""},
                    L: {url: ""},
                    XL: {url: ""},
                    XXL: {url: ""}
                }
            };
            content.image.url = post.photos.original;
            content.image.croppedUrl = post.photos.thumbnail;
            content.image.sizes.S.url = post.photos[this._smallPhotoSize];
            content.image.sizes.M.url = post.photos[this._mediumPhotoSize];
            content.image.sizes.L.url = post.photos[this._largePhotoSize];
            content.image.sizes.XL.url = post.photos[this._extraLargePhotoSize];
            content.image.sizes.XXL.url = post.photos[this._extraExtraLargePhotoSize];
        }

        if (post.type === 'video') {
            content.video = {
                id: ''
            };
        }

        transformed.content = content;

        if (post.type) {
            transformed.type = post.type;
            if (post.type === 'video') transformed.klass = PostVideo;
        }

        return transformed;
    },

    _resolveHeaderLabel: function(post) {
        if (post.mainSection)
            return post.mainSection;
        if (post.extras && post.extras.vertical)
            return post.extras.vertical;
        if (post.section && post.section.length > 0)
            return post.section[0];

        return '';
        // throw new Error('Given feed data have an item without fields' +
            // ' that can be used to resolve a "chapeu" field');
    },

    _resolveHeaderUrl: function(post) {
        if (post.mainSectionPermalink)
            return post.mainSectionPermalink;
        return '';
    },

    removePublieditorial: function(data) {
        return data.filter(this.isNotPublieditorial);
    },

    isNotPublieditorial: function(post) {
        if (post.extras && post.extras.pubeditorial_nome)
            return false;
        return true;
    },

    getCurrentPage: function() {
        return this._page;
    },

    hasNextPage: function(data) {
        if (data.length)
            return true;
        return false;
    }
};

module.exports = RecommendationAdapter;
